import React from 'react'

export function createStep({
    component = <></>,
    name = 'default_title',
    title = 'Default title',
    description = 'Default description',
    error = false,
    submit = false,
    finish = false,
    disabled = false,
    navigation = true,
    containerWidth = false,
    validation = {},
    icon = 'info.svg'
}) {
    return {
        name: name,
        title: title,
        description: description,
        error: error,
        submit: submit,
        disabled: disabled,
        navigation: navigation,
        icon: icon,
        Render: () => component,
        full_width: containerWidth,
        validation: validation,
        finish: finish
    }
}